import { NgModule } from '@angular/core';
import { EinPipe } from './ein.pipe';
import { SsnPipe } from './ssn.pipe';

@NgModule({
    declarations: [
        EinPipe,
        SsnPipe
    ],
    providers: [
        EinPipe,
        SsnPipe
    ],
    imports: [
    ],
    exports: [
        EinPipe,
        SsnPipe
    ]
})
export class CustomerPipeModule {
}
